import React from "react";
import { ModelManager } from "../../lib/model-manager";
import Pagination from "react-js-pagination";
import Moment from "moment/moment";
import { Link } from "react-router-dom";
import { FormattedDate } from "react-intl";

export default class Teams extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      elements: [],
      count: 0,
      activePage: 1,
      isLoading: true,
    };

    this.getElements = this.getElements.bind(this);
  }

  componentDidMount() {
    this.getElements();
  }

  getElements(page = 1) {
    this.setState({ isLoading: true });

    const uri = "/api/teams";
    ModelManager.fetchList(uri, { "order[beginAt]": "asc", page })
      .finally(() => this.setState({ isLoading: false }))
      .then((collection) => {
        this.setState({
          elements: collection.getMembers(),
          totalItems: collection.getTotalItems(),
          count: collection.getCount(),
          activePage: page,
        });
      });
  }

  handlePageChange(pageNumber) {
    this.getElements(pageNumber);
  }

  render() {
    Moment.locale("fr");
    const elements =
      this.state.elements.length > 0 ? (
        this.state.elements.map((element) => (
          <tr key={element.id}>
            <td>{element.name}</td>
            <td>
              <FormattedDate value={element.createdAt} />
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="99" align="center">
            Aucun élement
          </td>
        </tr>
      );

    return (
      <>
        <ul className="breadcrumb">
          <li>
            <Link to="/admin">Admin</Link>
          </li>
          <li className="active">Equipes</li>
        </ul>

        <div className="page-title">
          <h2>
            <span className="fa fa-arrow-circle-o-left" /> Equipes
          </h2>
          {this.props.user.editable && (
            <div className="btn-group pull-right">
              <Link to="/admin/team/create" className="btn btn-success">
                Créer une équipe
              </Link>
            </div>
          )}
        </div>

        <div className="page-content-wrap">
          {!this.state.isLoading ? (
            <div>
              <div className="alert alert-light border mb-3" role="alert">
                <strong>L&eacute;gende :</strong>{" "}
                <strong>Nom</strong> : nom de l&apos;&eacute;quipe &mdash;{" "}
                <strong>Date de cr&eacute;ation</strong> : date &agrave; laquelle l&apos;&eacute;quipe a &eacute;t&eacute; cr&eacute;&eacute;e
              </div>
              <table className="table table-condensed table-striped">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Date de création</th>
                  </tr>
                </thead>

                <tbody>{elements}</tbody>
              </table>

              {this.state.totalItems > import.meta.env.VITE_PER_PAGE ? (
                <nav className="pagination">
                  <Pagination
                    disabledClass="disabled"
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={this.state.activePage}
                    itemsCountPerPage={import.meta.env.VITE_PER_PAGE}
                    totalItemsCount={this.state.totalItems}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                  />
                </nav>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className="loading">
              <img src="/loading.gif" alt="loading" />
            </div>
          )}
        </div>
      </>
    );
  }
}
